import { render } from "./TesteComponente.vue?vue&type=template&id=33ba7a28"
import script from "./TesteComponente.vue?vue&type=script&lang=js"
export * from "./TesteComponente.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__